import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FiltersModule } from '../filters/filters.module';
import { SharedModule } from '../shared/shared.module';
import { UserCommunitiesComponent } from './components/user-communities/user-communities.component';
import { UserSelectMainCommunityComponent } from './user-select-main-community/user-select-main-community.component';

const moduleItems = [UserCommunitiesComponent, UserSelectMainCommunityComponent];

@NgModule({
    declarations: moduleItems,
    imports: [CommonModule, SharedModule, RouterModule, HttpClientModule, ReactiveFormsModule, FormsModule, FiltersModule],
    exports: moduleItems,
})
export class UserModule {}
